@if (shouldShowControl()) {
  <div gkControlRow>
    <div gkControlLabel [showLabel]="controlConfig.showLabel">
      <gk-translated-label [configLabel]="controlConfig.label"></gk-translated-label>:</div>
      <div gkControlValue [showLabel]="controlConfig.showLabel" gkControlColumn>
        @for (row of getRows(); track row; let last = $last) {
          <div gkControlRow [ngClass]="{'invisible-border' : last}">
            <div gkControlLabel [showLabel]="true">{{row.label | translate}}:</div>
            <div gkControlValue [showLabel]="true">{{row.value}}</div>
          </div>
        }
      </div>
    </div>
  }
